import {
  SolicitationStatBoolExp,
  SolicitationStatSelectColumn,
  useSolicitationStatsCountQuery,
} from 'generated/graphql';

type SolicitationStatsCounter = {
  count?: number;
  loading: boolean;
};

export const useSolicitationStatsCount = (
  where?: SolicitationStatBoolExp,
  unique?: boolean,
): SolicitationStatsCounter => {
  const distinct = (
    unique ? ['telephone', 'proViewId'] : []
  ) as SolicitationStatSelectColumn[];

  const { data, loading } = useSolicitationStatsCountQuery({
    variables: {
      where,
      distinct,
    },
  });

  return {
    loading,
    count: data?.solicitationStatAggregate.aggregate?.count,
  };
};
